const PathConstants = {
  BASE: '/',
  AUTH: '/auth',
  USER: 'home',
  ADMIN: 'admin',
  CREDIT: 'credit',
  HOLD: 'hold',
  VENDOR:'vendor',
  CANTEEN:'canteen',
  STAFF:'staff',
  NOT_FOUND: '*',
};

export default PathConstants;
